import * as React from 'react';

// Utils
// Constants
// Actions, Models & Interfaces
import { CoordinatesModel } from '@src/shared/src/models';
// Components
import { AdvancedMarker, AdvancedMarkerAnchorPoint } from '@vis.gl/react-google-maps';
// Styles
import '../styles/MapMarker.scss';
import { PinIcon } from '@toolkit/ui/icons';

type Props = {
  position: CoordinatesModel;
  locationLabel: string;
  dateLabel?: string;
};

const MapMarker: React.FC<Props> = ({ position, locationLabel, dateLabel = '' }) => (
  <AdvancedMarker position={position} anchorPoint={AdvancedMarkerAnchorPoint.BOTTOM_LEFT}>
    <div className="map-marker">
      <PinIcon />
      <div className="map-marker-box">
        {dateLabel && <div className="map-marker-date">{dateLabel}</div>}
        <div className="map-marker-location">{locationLabel}</div>
      </div>
    </div>
  </AdvancedMarker>
);

export default MapMarker;
